import './Accordion.scss';
import React, { memo } from 'react';

type AccordionProps = {
  header: React.ReactNode;
  children: React.ReactNode;
  open: boolean;
  disabled?: boolean;
};

export const Accordion = memo(({
  header,
  children,
  open,
  disabled = false,
}: AccordionProps) => (
  <div className="bp-accordion">
    {header}

    {!disabled && open && children}
  </div>
));
